const axios = require('axios').default;
const url = 'https://us-central1-mp-website-c4d97.cloudfunctions.net'

export const sendEmail = (body) => {
    return axios.post(`${url}/sendMail`, body)
}